export default __webpack_public_path__ + "static/media/delete_outline_black.08027a11.svg";